<script>
import { mapActions } from 'vuex';
import FilterComponent from '@/components/MainFilter/FilterComponent';
import NewFilterComponent from '@/components/MainFilter/NewFilterComponent';
import Sorting from '@/components/MainFilter/Sorting';
import CarList from '@/components/MainFilter/CarList';
import updateURLParameter from '@/utils/updateURLParameter';

const FILTER_NAMES_TO_MODIFY_URL = ['brands', 'models', 'nds'];

const DEFAULT_VALUES_FOR_FILTER_SKIP = {
  per_page: 12,
  sort_type: 'null|null',
};

export default {
  name: 'MainFilter',
  components: {
    FilterComponent,
    Sorting,
    CarList,
    NewFilterComponent,
  },
  props: {
    pageUrl: {
      type: String,
      required: true,
    },
    filterData: {
      type: Object,
      required: true,
    },

    title: {
      type: String,
    },
    otherCars: { type: Array },
    otherCarsTitle: {
      type: String,
    },
    otherModelCars: { type: Array },
    otherModelTitle: {
      type: String,
    },
    otherSoldCars: { type: Array },
    otherSoldTitle: {
      type: String,
    },
    otherBrandCars: { type: Array },
    otherBrandTitle: {
      type: String,
    },
    emptyCarsTitle: { type: String },
    filterPageData: {
      type: Object,
      default: () => ({}),
    },
    cars: {
      type: Array,
      default: () => [],
    },
    countCarsCurrentCity: {
      type: Number,
      required: true,
    },
    countCarsOtherCity: {
      type: Number,
      default: null,
    },
    numberPages: {
      type: Number,
      required: true,
    },
    typePage: {
      type: String,
      required: true,
    },
    stock: {
      type: String,
      default: null,
    },
    isLanding: {
      type: Boolean,
      default: false,
    },
    autoOrderUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filters: {
        hot_offer: null,
        created_at: null,
        brands: [],
        models: [],
        credit: null,
        bodies: [],
        fuel: [],
        kpp: [],
        min_probeg: null,
        power: {
          min: null,
          max: null,
        },
        mileage: {
          min: null,
          max: null,
        },
        year: [],
        volumes: {
          min: null,
          max: null,
        },
        price: {
          min: null,
          max: null,
        },
        dealers: [],
      },
      credit: false,
      emitAjax: false,
      phpRender: true,
      skipModel: false,
      sorting: {
        sort: null,
        perPage: {
          name: 0,
        },
      },
      page: null,
      resetSorting: false,
      checkboxes: [
        'hot_offer',
        'cool_cars',
        'credit',
        'created_at',
        'for_family',
        'has_warranty',
        'min_probeg',

        'nizkiy_nalog',
        'novinki_nedeli',
        'one_owner',
        'vygoda_yur_lica',
      ],
    };
  },
  computed: {
    params() {
      const params = {};
      this.filters &&
        Object.keys(this.filters).forEach(name => {
          if (this.filters[name] instanceof Array) {
            this.filters[name].forEach(item => {
              if (item?.name?.length > 0) {
                if (!params[name]) {
                  params[name] = [];
                }
                params[name].push(item.id);
              } else {
                params[name] = this.filters[name];
              }
            });
          } else if (this.filters[name] instanceof Object) {
            if (this.checkboxes.includes(name)) {
              params[name] = this.filters[name].id;
            } else {
              if (
                this.filters[name].min &&
                this.filters[name].min !== this.filterData[name].min
              ) {
                params[`${name}_min`] = this.filters[name].min;
              }
              if (
                this.filters[name].max &&
                this.filters[name].max !== this.filterData[name].max
              ) {
                params[`${name}_max`] = this.filters[name].max;
              }
            }
          }
        });
      if (this.stock) {
        params.stock = this.stock;
      }

      return params;
    },
  },
  watch: {
    filters: {
      handler(value) {
        this.updateFilter();
      },
      deep: true,
    },
    'filters.credit'(val) {
      if (val) {
        return (this.credit = 'credit');
      }
      this.credit = null;
    },
    'filters.nds'(val) {
      if (val) {
        return (this.credit = 'nds');
      }
      this.credit = null;
    },
  },
  mounted() {},
  methods: {
    ...mapActions({
      fetchFilter: 'Filter/fetchFilter',
      fetchFilterParams: 'Filter/fetchFilterParams',
    }),

    changeFilters(filters) {
      this.filters = filters;
    },
    changeSorting(sorting) {
      this.sorting = sorting;
    },
    changePage(page) {
      this.uploadsData(page);
    },
    updateFilter() {
      this.changeUrl();
      this.uploadsData();
    },
    changeUrl() {
      let url = `${document.location.origin}${this.pageUrl}/`;
      const SHOULD_SKIP_NAME = {
        brands: false,
        models: false,
        nds: false,
      };

      if ((this.filters.nds || []).length === 1) {
        url += 'vat/';
        SHOULD_SKIP_NAME.nds = true;
      }

      // Обрабатываем бренд
      if ((this.filters.brands || []).length === 1) {
        const brand = this.filters.brands[0];
        url += `${brand.url}/`; // Добавляем бренд в URL
        SHOULD_SKIP_NAME.brands = true;

        // Обрабатываем модель
        if ((this.filters.models || []).length === 1) {
          const model = this.filters.models[0];
          let correctedModelUrl = model.url;
          // Убираем дублирование бренда в URL
          if (correctedModelUrl.startsWith(`/${brand.url}/`)) {
            correctedModelUrl = correctedModelUrl.replace(`/${brand.url}/`, '');
          }

          if (this.stock !== 'stock') {
            // Для нестандартных случаев stock URL
            url = `${document.location.origin}${correctedModelUrl}`;
          } else {
            url += correctedModelUrl;
          }

          SHOULD_SKIP_NAME.models = true;
        }
      }

      Object.keys(this.filters).forEach(name => {
        if (this.checkboxes.includes(name)) {
          url = updateURLParameter(
            url,
            name,
            Boolean(this.filters[name]) ? 1 : false,
          );
        } else if (this.filters[name] instanceof Array) {
          if (
            !(
              FILTER_NAMES_TO_MODIFY_URL.includes(name) &&
              this.filters[name].length === 1 &&
              SHOULD_SKIP_NAME[name]
            )
          ) {
            url = updateURLParameter(
              url,
              name,
              Boolean(this.filters[name]) ? this.filters[name] : undefined,
            );
          }
        } else if (this.filters[name] instanceof Object) {
          if (this.filters[name]?.min !== this.filterData[name]?.min) {
            url = updateURLParameter(
              url,
              `${name}_min`,
              this.filters[name].min,
            );
          }
          if (this.filters[name]?.max !== this.filterData[name]?.max) {
            url = updateURLParameter(
              url,
              `${name}_max`,
              this.filters[name].max,
            );
          }
        }
      });

      const sort = `${this.sorting.sort.order_by}|${this.sorting.sort.dir}`;
      if (DEFAULT_VALUES_FOR_FILTER_SKIP['sort_type'] !== sort) {
        url = updateURLParameter(url, 'sort_type', sort);
      }

      if (
        url.includes('?') &&
        String(DEFAULT_VALUES_FOR_FILTER_SKIP['per_page']) !==
          String(this.sorting.perPage.name)
      ) {
        url = updateURLParameter(url, 'per_page', this.sorting.perPage.name);
      }

      const canonical = document.head.querySelector('[rel="canonical"]');
      if (canonical) {
        canonical.href = url;
      }

      history.pushState(null, null, url);
    },
    uploadsData(page, waitForRequestFilterParams) {
      if (!this.emitAjax) return;
      this.changePhpRender(false);
      this.page = page || 1;
      const params = this.params;

      params.sort_type = `${this.sorting.sort.order_by}|${this.sorting.sort.dir}`;
      params.per_page = Number(this.sorting.perPage.name);
      if (params.sort_type === 'null|null') {
        delete params.sort_type;
      }
      const data = {
        params: params,
        type_page: this.typePage,
        page: this.page,
      };

      const dataFilterParams = {
        params: this.params,
        waitForRequestFilterParams: waitForRequestFilterParams,
      };

      if (this.page === 1) {
        this.fetchFilterParams(dataFilterParams);
      }
      return this.fetchFilter(data);
    },
    resetAllFilter() {
      this.resetSorting = true;
      history.pushState(
        null,
        null,
        `${document.location.origin}${document.location.pathname}`,
      );
      setTimeout(() => {
        this.uploadsData();
      }, 500);
    },
    allowAjax(val) {
      this.emitAjax = val;
    },
    changePhpRender(val) {
      this.phpRender = val;
    },
  },
};
</script>

<template>
  <div
    class="flex items-start flex-col lg:flex-row"
    :class="{
      'flex-col': typePage === 'used',
      'lg:flex-col': typePage === 'used',
    }"
  >
    <filter-component
      v-if="typePage !== 'used'"
      :filter-data="filterData"
      :filter-page-data="filterPageData"
      type-page="used"
      :is-landing="isLanding"
      @change-filters="changeFilters"
      @update-filter="updateFilter"
      @uploads-data="uploadsData"
      @reset-all-filter="resetAllFilter"
    ></filter-component>
    <new-filter-component
      v-if="typePage === 'used'"
      :filter-data="filterData"
      :checkboxes="checkboxes"
      :filter-page-data="filterPageData"
      type-page="used"
      :is-landing="isLanding"
      @change-filters="changeFilters"
      @update-filter="updateFilter"
      @uploads-data="uploadsData"
      @reset-all-filter="resetAllFilter"
      :count-cars-current-city="countCarsCurrentCity"
    ></new-filter-component>
    <div class="w-full">
      <sorting
        v-if="cars"
        :count-cars-current-city="countCarsCurrentCity"
        :reset-sorting="resetSorting"
        @change-sorting="changeSorting"
        @update-filter="updateFilter"
      ></sorting>

      <car-list
        :cars="cars"
        :page="page"
        :credit="credit"
        :title="title"
        :php-render="phpRender"
        :other-cars="otherCars"
        :other-cars-title="otherCarsTitle"
        :other-model-cars="otherModelCars"
        :other-model-title="otherModelTitle"
        :other-sold-cars="otherSoldCars"
        :other-sold-title="otherSoldTitle"
        :other-brand-cars="otherBrandCars"
        :other-brand-title="otherBrandTitle"
        :empty-cars-title="emptyCarsTitle"
        :number-pages="numberPages"
        :type-page="typePage"
        :stock="stock"
        :is-landing="isLanding"
        :perPage="sorting.perPage?.name"
        :count-cars-current-city="countCarsCurrentCity"
        :count-cars-other-city="countCarsOtherCity"
        :auto-order-url="autoOrderUrl"
        @change-page="changePage"
        @allow-ajax="allowAjax"
      ></car-list>
    </div>
  </div>
</template>
